exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ".NoMatchesView-module__no_matches_container__2Oto1 {\n  border-top: 1px solid #C4C4C4;\n  padding: 60px 15px 15px;\n  text-align: center;\n  margin-right: 10px;\n}\n.NoMatchesView-module__add_match_request__3_HWT {\n  margin: 10px 0 0 0;\n}\n.NoMatchesView-module__link__1sNKB {\n  min-width: auto;\n  width: auto;\n  padding: 0 4px;\n  height: 16px;\n  line-height: 1.2em;\n}\n.NoMatchesView-module__icon__Sqh-W {\n  margin-left: 3px;\n}\n:root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n", ""]);

// Exports
exports.locals = {
	"no_matches_container": "NoMatchesView-module__no_matches_container__2Oto1",
	"add_match_request": "NoMatchesView-module__add_match_request__3_HWT",
	"link": "NoMatchesView-module__link__1sNKB",
	"icon": "NoMatchesView-module__icon__Sqh-W"
};